import { API } from 'aws-amplify';
import { GRAPHQL_QUERY_LIMIT } from 'constants/common';
import { isEmpty } from 'lodash';

export const getAllRows = async (
  query: any,
  listName: string,
  variables: Object = {}
): Promise<any[]> => {
  let result: any[] = [];
  let nextToken: string | null = null;
  do {
    try {
      const responseData: any = await API.graphql({
        query,
        variables: { ...variables, limit: GRAPHQL_QUERY_LIMIT, nextToken },
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      });
      const data: any = responseData?.data?.[listName];
      result = [...result, ...(data?.items ?? [])];
      nextToken = data?.nextToken;
    } catch (error) {
      console.log('Error: ', error);
      return [];
    }
  } while (!isEmpty(nextToken));
  return result;
};

export const getFirstRow = async (
  query: any,
  listName: string,
  variables: Object = {}
): Promise<any> => {
  let nextToken: string | null = null;
  do {
    try {
      const responseData: any = await API.graphql({
        query,
        variables: { ...variables, limit: GRAPHQL_QUERY_LIMIT, nextToken },
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      });
      const data: any = responseData?.data?.[listName];
      const result = data?.items?.[0];
      if (result !== undefined && result !== null) return result;
      nextToken = data?.nextToken;
    } catch (error) {
      console.log('Error: ', error);
      return [];
    }
  } while (!isEmpty(nextToken));
  return null;
};
